<template>
  <div class="screen">
    <div class="top">
      <div class="text" v-if="logoForm.enTitle">
        {{ this.$i18n.locale == "en" ? logoForm.enTitle : logoForm.title }}
      </div>
      <div class="text" v-else>
        {{ $t("name") }}
      </div>
      <div class="up"></div>
      <div class="down"></div>
    </div>
    <div class="content">
      <div class="left">
        <div class="bg"></div>
        <div class="devList">
          <div class="title">{{ $t("screen.deviceNumCount") }}</div>
          <div class="card">
            <div
              class="list"
              :style="{
                top: -25 * num + '%',
                transition: transition
              }"
            >
              <div class="item" v-for="i in list" :key="i.typeCode">
                <div class="icon">
                  <i class="iconfont" :class="`icon-${i.icon}`" icon />
                </div>
                <div class="dev">
                  <div class="val">{{ i.typeName }}</div>
                  <div class="num">
                    <span class="v">{{ i.deviceCount }}</span>
                    <!-- <span class="n">个</span> -->
                  </div>
                </div>
              </div>
            </div>
            <div
              class="list"
              :style="{
                top: -25 * num + 25 * (Math.ceil(list.length / 2) - 4) + '%',
                transition: transition
              }"
            >
              <div class="item" v-for="i in list" :key="i.typeCode">
                <div class="icon">
                  <i class="iconfont" :class="`icon-${i.icon}`" icon />
                </div>
                <div class="dev">
                  <div class="val">{{ i.typeName }}</div>
                  <div class="num">
                    <span class="v">{{ i.deviceCount }}</span>
                    <!-- <span class="n">个</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item deviceType">
          <div class="title">{{ $t("screen.deviceTypeCount") }}</div>
          <div class="device">
            <div ref="myCharts" id="myCharts" class="myCharts"></div>
            <div class="legend">
              <div class="legend-item">
                <div>
                  <span class="point"></span>{{ $t("screen.onlineCount") }}
                </div>
                <div class="num">{{ deviceType.onlineCount }}</div>
              </div>
              <div class="legend-item finish">
                <div>
                  <span class="point"></span>{{ $t("screen.unOnlineCount") }}
                </div>
                <div class="num">{{ deviceType.unOnlineCount }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="item alarm">
          <div class="title">{{ $t("alarm.alarmInfo") }}</div>
          <div class="alarmtable">
            <dv-scroll-board
              :config="configTable"
              style="width: 100%; height: 100%"
            />
          </div>
        </div>
      </div>
      <div class="center">
        <div class="bg">
          <div class="corner"></div>
          <div class="bottom"></div>
        </div>
        <div class="bg bgr">
          <div class="corner"></div>
          <div class="bottom"></div>
        </div>
        <div class="cabinetNum">
          <div class="cir">
            <Circles
              width="5"
              color="#47E5BC"
              :percentNum="cabinetCount.multiple"
              backgroundColor="#092C2D"
              fontSize="30px"
              icon="duoguiti"
            />
          </div>
          <div class="cabNum">
            <!-- cabinetCount: { multipleCount: 0, singleCount: 0, multiple: 50,
            single: 50, total: 0 }, -->
            <div class="row">
              <div class="num">{{ cabinetCount.multipleCount }}</div>
              <div class="text">{{ $t("screen.multipleCount") }}</div>
            </div>
            <div class="row">
              <div class="num">{{ cabinetCount.multiple }}%</div>
              <div class="text">{{ $t("screen.Percentage") }}</div>
            </div>
          </div>
          <div class="cabtTotal">
            <div class="text">{{ $t("screen.totalNumber") }}</div>
            <div class="totalList">
              <div v-for="(i, index) in cabinetCount.totalList" :key="index">
                {{ i }}
              </div>
            </div>
          </div>
          <div class="cabNum">
            <div class="row">
              <div class="num">{{ cabinetCount.singleCount }}</div>
              <div class="text">{{ $t("screen.singleCount") }}</div>
            </div>
            <div class="row">
              <div class="num">{{ cabinetCount.single }}%</div>
              <div class="text">{{ $t("screen.Percentage") }}</div>
            </div>
          </div>
          <div class="cir">
            <Circles
              width="5"
              color="#47E5BC"
              :percentNum="cabinetCount.single"
              backgroundColor="#092C2D"
              fontSize="30px"
            />
          </div>
        </div>
        <div class="mapBox">
          <el-autocomplete
            class="search"
            v-model="searchItem"
            :fetch-suggestions="querySearch"
            prefix-icon="el-icon-search"
            :placeholder="$t('pEnter') + $t('device.deviceCode')"
            clearable
            @select="handleFilter"
          ></el-autocomplete>
          <div id="myMap" ref="myMap"></div>
        </div>
        <div class="echartBox">
          <div class="item">
            <div class="title">
              <span>{{ $t("screen.power") }}</span>
              <span class="drop">{{ seletedItem.deviceName }}</span>
            </div>
            <div class="info">
              <div
                class="box"
                ref="powerbox"
                :style="{
                  top: -18 * powerNum + 'px',
                  transition: powerTransition
                }"
              >
                <div v-for="i in powerInfo" :key="i.dictionaryId">
                  <div class="label">
                    {{ i.signName }}
                  </div>
                  <div class="value">
                    {{ i.value }}
                  </div>
                </div>
              </div>
              <div
                class="box"
                :style="{
                  top: -18 * powerNum + 'px',
                  transition: powerTransition
                }"
                v-if="powershow"
              >
                <div v-for="i in powerInfo" :key="i.dictionaryId">
                  <div class="label">
                    {{ i.signName }}
                  </div>
                  <div class="value">
                    {{ i.value }}
                  </div>
                </div>
              </div>
            </div>
            <div id="powerEchart" class="echart"></div>
          </div>
          <div class="item">
            <div class="title">
              <span>{{ $t("screen.rectify") }}</span>
              <span class="drop">{{ seletedItem.deviceName }}</span>
            </div>
            <div class="info">
              <div
                class="box"
                ref="rectifybox"
                :style="{
                  top: -18 * rectifyNum + 'px',
                  transition: rectifyTransition
                }"
              >
                <div v-for="i in rectifyInfo" :key="i.dictionaryId">
                  <div class="label">
                    {{ i.signName }}
                  </div>
                  <div class="value">
                    {{ i.value }}
                  </div>
                </div>
              </div>
              <div
                class="box"
                :style="{
                  top: -18 * rectifyNum + 'px',
                  transition: rectifyTransition
                }"
                v-if="rectifyshow"
              >
                <div v-for="i in rectifyInfo" :key="i.dictionaryId">
                  <div class="label">
                    {{ i.signName }}
                  </div>
                  <div class="value">
                    {{ i.value }}
                  </div>
                </div>
              </div>
            </div>
            <div id="rectifyEchart" class="echart"></div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="bg"></div>
        <div class="devInfo">
          <div class="title">
            <span>{{ $t("screen.basicInfo") }}</span>
            <span class="drop">{{ seletedItem.deviceName }}</span>
          </div>
          <div class="cabinetInfo">
            <div class="img">
              <i class="iconfont" :class="`icon-duoguiti`" icon />
            </div>
            <div class="box">
              <div class="text" v-for="(item, i) in cabinetInfo" :key="i">
                <span class="lab" :style="{ marginLeft: item.width }">{{
                  item.label
                }}</span>
                <span class="line"></span>
                <span class="val">{{ siteInfo[item.value] + item.unit }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="environmental">
          <div class="title">
            <span>{{ $t("screen.environmental") }}</span>
            <span class="drop">{{ seletedItem.deviceName }}</span>
          </div>
          <div class="info">
            <div
              class="box"
              ref="sensorbox"
              :style="{
                top: -18 * sensorNum + 'px',
                transition: sensorTransition
              }"
            >
              <div v-for="i in sensorInfo" :key="'1' + i.dictionaryId">
                <div class="label">
                  {{ i.signName }}
                </div>
                <div class="value">
                  {{ i.value }}
                </div>
              </div>
            </div>
            <div
              class="box"
              :style="{
                top: -18 * sensorNum + 'px',
                transition: sensorTransition
              }"
              v-if="sensorshow"
            >
              <div v-for="i in sensorInfo" :key="'2' + i.dictionaryId">
                <div class="label">
                  {{ i.signName }}
                </div>
                <div class="value">
                  {{ i.value }}
                </div>
              </div>
            </div>
          </div>
          <div id="sensorEchart" class="echart"></div>
        </div>
        <div class="battery">
          <div class="title">
            <span>{{ $t("screen.battery") }}</span>
            <span class="drop">{{ seletedItem.deviceName }}</span>
          </div>
          <div class="info">
            <div
              class="box"
              ref="batterybox"
              :style="{
                top: -18 * batteryNum + 'px',
                transition: batteryTransition
              }"
            >
              <div v-for="i in batteryInfo" :key="'3' + i.dictionaryId">
                <div class="label">
                  {{ i.signName }}
                </div>
                <div class="value">
                  {{ i.value }}
                </div>
              </div>
            </div>
            <div
              class="box"
              :style="{
                top: -18 * batteryNum + 'px',
                transition: batteryTransition
              }"
              v-if="batteryshow"
            >
              <div v-for="i in batteryInfo" :key="'4' + i.dictionaryId">
                <div class="label">
                  {{ i.signName }}
                </div>
                <div class="value">
                  {{ i.value }}
                </div>
              </div>
            </div>
          </div>
          <div id="batteryEchart" class="echart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCabinetCountInfo,
  getDeviceCountInfo,
  getDeviceStatusInfo,
  getBatteryCurve,
  getBatteryInfo,
  getSensorCurve,
  getSensorInfo,
  getRectifyCurve,
  getRectifyInfo,
  getPowerCurve,
  getPowerInfo
} from "@/api/screen"
import { getCabinetBeanById } from "@/api/cabinetDetails"
import { getCabinetList } from "@/api/device"
import Circles from "../../components/perCircular/icon.vue"
import * as echarts from "echarts"
import "echarts-gl"
import { getAlarmList } from "@/api/alarm"
export default {
  name: "Screen",
  components: { Circles },
  data() {
    return {
      searchItem: "",
      mapList: [],
      seletedItem: {},
      map: null,

      num: 0,
      upDatetimer: null,
      timer: null,
      transition: null,
      echartTimer: null,
      batteryshow: true,
      batteryNum: 0,
      batteryTransition: null,
      sensorshow: true,
      sensorNum: 0,
      sensorTransition: null,
      rectifyshow: true,
      rectifyNum: 0,
      rectifyTransition: null,
      powershow: true,
      powerNum: 0,
      powerTransition: null,
      rectifyNums: 0,
      powerNums: 0,
      sensorNums: 0,
      batteryNums: 0,
      cabinetCount: {
        multipleCount: 0,
        singleCount: 0,
        multiple: 0,
        single: 0,
        total: 0,
        totalList: [0, 0, 0, 0, 1]
      },
      list: [],
      deviceType: {},
      configTable: {
        header: [
          this.$t("device.deviceName"),
          this.$t("alarm.alarmInfo"),
          this.$t("alarm.uploadTime"),
          this.$t("alarm.status")
        ],
        data: [],
        rowNum: 6, //表格行数
        headerBGC: "rgba(43, 244, 201, 0.15)", //表头
        evenRowBGC: "rgba(43, 244, 201, 0.1)", //奇数行
        oddRowBGC: "rgba(43, 244, 201, 0.05)", //偶数行
        // index: true,
        waitTime: 4000,
        align: ["left", "left", "left", "center"],
        // columnWidth: ['15%', '35%', '30%', '20%']
        columnWidth: [60]
      },
      cabinetInfo: [
        {
          label: this.$t("cabinet.info.longitude"),
          value: "longitude",
          width: "37px",
          unit: "°E"
        },
        {
          label: this.$t("cabinet.info.latitude"),
          value: "latitude",
          width: "74px",
          unit: "°N"
        },
        {
          label: this.$t("cabinet.info.siteName"),
          value: "siteName",
          width: "82px",
          unit: ""
        },
        {
          label: this.$t("cabinet.info.siteCode"),
          value: "siteCode",
          width: "80px",
          unit: ""
        },
        {
          label: this.$t("cabinet.info.address"),
          value: "address",
          width: "60px",
          unit: ""
        },
        {
          label: this.$t("cabinet.info.director"),
          value: "director",
          width: "20px",
          unit: ""
        }
      ],
      siteInfo: {},
      batteryCurve: {},
      batteryInfo: [],
      sensorCurve: {},
      sensorInfo: [],
      rectifyCurve: {},
      rectifyInfo: [],
      powerCurve: {},
      powerInfo: []
    }
  },
  computed: {
    logoForm: {
      get() {
        return this.$store.state.user.logoForm
      }
    }
  },
  activated() {
    this.getCabinetList()
    getBatteryCurve({ deviceCode: "saf" })
  },
  mounted() {
    console.log(this.logoForm, "this.")
    let app = document.getElementById("app")
    app.classList.add("largeScreen")
    this.getList()
    this.upDatetimer = setTimeout(() => {
      this.updateData()
    }, 5000)
  },
  destroyed() {
    let app = document.getElementById("app")
    app.classList.remove("largeScreen")
    clearInterval(this.timer)
    clearInterval(this.echartTimer)
    this.upDatetimer && clearTimeout(this.upDatetimer)
    this.upDatetimer = null
  },
  methods: {
    async getList() {
      this.getCabinetCountInfo()
      this.getDeviceStatusInfo()
      this.getAlarmList()
      getDeviceCountInfo().then((e) => {
        this.list =
          e.data.length &&
          e.data.map((e) => {
            e.icon = this.getIcon(e.typeCode)
            e.deviceCount = e.deviceCount || 0
            return e
          })
        this.timer = setInterval(() => {
          this.num += 1
          if (
            this.num >=
            this.list.length / 2 + (Math.ceil(this.list.length / 2) - 5)
          ) {
            setTimeout(() => {
              this.transition = `inherit`
              this.num = 0
              setTimeout(() => {
                this.transition = `0.3s`
              }, 300)
            }, 1000)
          }
        }, 2000)
      })
      await getCabinetList().then((e) => {
        console.log(e)
        const maplist = []
        this.mapList = e.data.list.map((i) => {
          const result = maplist.filter((item) => item === i.siteCode)
          maplist.push(i.siteCode)
          i.numIndex = result.length
          return i
        })
        this.seletedItem = this.mapList[0] || {}
        this.initMap().then(() => {
          // eslint-disable-next-line no-undef
          console.log("加载成功...", Microsoft)
          this.loadingMap()
        })
      })
      getCabinetBeanById({ deviceId: this.seletedItem.deviceId }).then((e) => {
        this.siteInfo = e.data.site || {}
      })
      getBatteryCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.batteryCurve = []
        //         field :  "Ambient temperature"
        // measurement :  "IEMS2_device_dictionary"
        // start :  "2023-11-24T00:13:17.352896736Z"
        // stop :  "2023-11-24T01:13:17.352896736Z"
        // table :  0 time :  "2023-11-24T00:22:00.342Z"
        // value :  "32.9"
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.batteryCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.batteryCurve, "batteryEchart")
        console.log(this.batteryCurve)
      })
      await getBatteryInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          this.batteryInfo =
            e.data.length &&
            e.data.map((e) => {
              if (this.$i18n.locale == "en") {
                e.signName = e.enSignName
              }
              if (e.mean && e.value) {
                const mean = {}
                let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
                str.split(";").forEach((i) => {
                  i = i.split(":")
                  mean[i[0]] = i[1]
                })
                console.log(e.value, mean[e.value], e.mean)
                e.value = mean[e.value]
              }
              if (e.factor > 1 && e.value) {
                e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
              }
              if (e.unit && e.value) {
                e.value = e.value + " " + e.unit
              }
              if (!e.value) {
                e.value = this.$t("cabinet.sensor.noData")
              }
              return e
            })
        }
      )
      getSensorCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.sensorCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.sensorCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.sensorCurve, "sensorEchart")
      })
      await getSensorInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          let list = []
          for (let key in e.data) {
            list = [...list, ...e.data[key]]
          }
          this.sensorInfo = list.map((e) => {
            if (this.$i18n.locale == "en") {
              e.signName = e.enSignName
            }
            if (e.mean && e.value) {
              const mean = {}
              let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
              str.split(";").forEach((i) => {
                i = i.split(":")
                mean[i[0]] = i[1]
              })
              // console.log(e.value, mean[e.value], e.mean)
              e.value = mean[e.value]
            }
            if (e.factor > 1 && e.value) {
              e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
            }
            if (e.unit && e.value) {
              e.value = e.value + " " + e.unit
            }
            if (!e.value) {
              e.value = this.$t("cabinet.sensor.noData")
            }
            return e
          })
        }
      )
      getRectifyCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.rectifyCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.rectifyCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.rectifyCurve, "rectifyEchart")
      })
      await getRectifyInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          this.rectifyInfo =
            e.data.length &&
            e.data.map((e) => {
              if (this.$i18n.locale == "en") {
                e.signName = e.enSignName
              }
              if (e.mean && e.value) {
                const mean = {}
                let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
                str.split(";").forEach((i) => {
                  i = i.split(":")
                  mean[i[0]] = i[1]
                })
                // console.log(e.value, mean[e.value], e.mean)
                e.value = mean[e.value]
              }
              if (e.factor > 1 && e.value) {
                e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
              }
              if (e.unit && e.value) {
                e.value = e.value + " " + e.unit
              }
              if (!e.value) {
                e.value = this.$t("cabinet.sensor.noData")
              }
              return e
            })
        }
      )
      getPowerCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.powerCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.powerCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.powerCurve, "powerEchart")
      })
      await getPowerInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          this.powerInfo =
            e.data.length &&
            e.data.map((e) => {
              if (this.$i18n.locale == "en") {
                e.signName = e.enSignName
              }
              if (e.mean && e.value) {
                const mean = {}
                let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
                str.split(";").forEach((i) => {
                  i = i.split(":")
                  mean[i[0]] = i[1]
                })
                // console.log(e.value, mean[e.value], e.mean)
                e.value = mean[e.value]
              }
              if (e.factor > 1 && e.value) {
                e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
              }
              if (e.unit && e.value) {
                e.value = e.value + " " + e.unit
              }
              if (!e.value) {
                e.value = this.$t("cabinet.sensor.noData")
              }
              return e
            })
        }
      )
      this.$nextTick(() => {
        console.log("------------2-----------")
        this.echartTimer && clearInterval(this.echartTimer)
        this.rectifyNums = this.$refs.rectifybox.clientHeight / 18
        this.powerNums = this.$refs.powerbox.clientHeight / 18
        this.sensorNums = this.$refs.sensorbox.clientHeight / 18
        this.batteryNums = this.$refs.batterybox.clientHeight / 18
        // console.log(
        //   this.rectifyNums,
        //   this.powerNums,
        //   this.sensorNums,
        //   this.batteryNums
        // )
        this.echartTimer = setInterval(() => {
          console.log("------------3-----------")
          if (this.rectifyNums > 12) {
            this.rectifyshow = true
            this.rectifyNum += 1
            if (this.rectifyNum == this.rectifyNums) {
              setTimeout(() => {
                this.rectifyTransition = `inherit`
                this.rectifyNum = 0
                setTimeout(() => {
                  this.rectifyTransition = `0.3s`
                }, 300)
              }, 1000)
            }
          } else {
            this.rectifyshow = false
          }
          if (this.powerNums > 12) {
            this.powershow = true
            this.powerNum += 1
            if (this.powerNum == this.powerNums) {
              setTimeout(() => {
                this.powerTransition = `inherit`
                this.powerNum = 0
                setTimeout(() => {
                  this.powerTransition = `0.3s`
                }, 300)
              }, 1000)
            }
          } else {
            this.powershow = false
          }
          if (this.sensorNums > 12) {
            this.sensorshow = true
            this.sensorNum += 1
            if (this.sensorNum == this.sensorNums) {
              setTimeout(() => {
                this.sensorTransition = `inherit`
                this.sensorNum = 0
                setTimeout(() => {
                  this.sensorTransition = `0.3s`
                }, 300)
              }, 1000)
            }
          } else {
            this.sensorshow = false
          }
          if (this.batteryNums > 12) {
            this.batteryshow = true
            this.batteryNum += 1
            if (this.batteryNum == this.batteryNums) {
              setTimeout(() => {
                this.batteryTransition = `inherit`
                this.batteryNum = 0
                setTimeout(() => {
                  this.batteryTransition = `0.3s`
                }, 300)
              }, 1000)
            }
          } else {
            this.batteryshow = false
          }
        }, 2000)
      })
    },
    async updateData() {
      this.getCabinetCountInfo()
      this.getDeviceCountInfo()
      this.getDeviceStatusInfo()
      this.getAlarmList()
      await getCabinetList().then((e) => {
        // console.log(e)
        const maplist = []
        this.mapList = e.data.list.map((i) => {
          const result = maplist.filter((item) => item === i.siteCode)
          maplist.push(i.siteCode)
          i.numIndex = result.length
          return i
        })
      })
      getCabinetBeanById({ deviceId: this.seletedItem.deviceId }).then((e) => {
        this.siteInfo = e.data.site || {}
      })
      getBatteryCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.batteryCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.batteryCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.batteryCurve, "batteryEchart")
        console.log(this.batteryCurve)
      })
      await getBatteryInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          this.batteryInfo =
            e.data.length &&
            e.data.map((e) => {
              if (this.$i18n.locale == "en") {
                e.signName = e.enSignName
              }
              if (e.mean && e.value) {
                const mean = {}
                let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
                str.split(";").forEach((i) => {
                  i = i.split(":")
                  mean[i[0]] = i[1]
                })
                // console.log(e.value, mean[e.value], e.mean)
                e.value = mean[e.value]
              }
              if (e.factor > 1 && e.value) {
                e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
              }
              if (e.unit && e.value) {
                e.value = e.value + " " + e.unit
              }
              if (!e.value) {
                e.value = this.$t("cabinet.sensor.noData")
              }
              return e
            })
        }
      )
      getSensorCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.sensorCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.sensorCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.sensorCurve, "sensorEchart")
      })
      await getSensorInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          let list = []
          for (let key in e.data) {
            list = [...list, ...e.data[key]]
          }
          this.sensorInfo = list.map((e) => {
            if (this.$i18n.locale == "en") {
              e.signName = e.enSignName
            }
            if (e.mean && e.value) {
              const mean = {}
              let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
              str.split(";").forEach((i) => {
                i = i.split(":")
                mean[i[0]] = i[1]
              })
              // console.log(e.value, mean[e.value], e.mean)
              e.value = mean[e.value]
            }
            if (e.factor > 1 && e.value) {
              e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
            }
            if (e.unit && e.value) {
              e.value = e.value + " " + e.unit
            }
            if (!e.value) {
              e.value = this.$t("cabinet.sensor.noData")
            }
            return e
          })
        }
      )
      getRectifyCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.rectifyCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.rectifyCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.rectifyCurve, "rectifyEchart")
      })
      await getRectifyInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          this.rectifyInfo =
            e.data.length &&
            e.data.map((e) => {
              if (this.$i18n.locale == "en") {
                e.signName = e.enSignName
              }
              if (e.mean && e.value) {
                const mean = {}
                let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
                str.split(";").forEach((i) => {
                  i = i.split(":")
                  mean[i[0]] = i[1]
                })
                // console.log(e.value, mean[e.value], e.mean)
                e.value = mean[e.value]
              }
              if (e.factor > 1 && e.value) {
                e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
              }
              if (e.unit && e.value) {
                e.value = e.value + " " + e.unit
              }
              if (!e.value) {
                e.value = this.$t("cabinet.sensor.noData")
              }
              return e
            })
        }
      )
      getPowerCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.powerCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.powerCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.powerCurve, "powerEchart")
      })
      await getPowerInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          this.powerInfo =
            e.data.length &&
            e.data.map((e) => {
              if (this.$i18n.locale == "en") {
                e.signName = e.enSignName
              }
              if (e.mean && e.value) {
                const mean = {}
                let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
                str.split(";").forEach((i) => {
                  i = i.split(":")
                  mean[i[0]] = i[1]
                })
                // console.log(e.value, mean[e.value], e.mean)
                e.value = mean[e.value]
              }
              if (e.factor > 1 && e.value) {
                e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
              }
              if (e.unit && e.value) {
                e.value = e.value + " " + e.unit
              }
              if (!e.value) {
                e.value = this.$t("cabinet.sensor.noData")
              }
              return e
            })
        }
      )
      this.upDatetimer = setTimeout(() => {
        this.upDatetimer && this.updateData()
      }, 6000)
    },
    async changeCabinet() {
      getCabinetBeanById({ deviceId: this.seletedItem.deviceId }).then((e) => {
        this.siteInfo = e.data.site || {}
      })
      getBatteryCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.batteryCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.batteryCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.batteryCurve, "batteryEchart")
        console.log(this.batteryCurve)
      })
      await getBatteryInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          this.batteryInfo =
            e.data.length &&
            e.data.map((e) => {
              if (this.$i18n.locale == "en") {
                e.signName = e.enSignName
              }
              if (e.mean && e.value) {
                const mean = {}
                let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
                str.split(";").forEach((i) => {
                  i = i.split(":")
                  mean[i[0]] = i[1]
                })
                // console.log(e.value, mean[e.value], e.mean)
                e.value = mean[e.value]
              }
              if (e.factor > 1 && e.value) {
                e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
              }
              if (e.unit && e.value) {
                e.value = e.value + " " + e.unit
              }
              if (!e.value) {
                e.value = this.$t("cabinet.sensor.noData")
              }
              return e
            })
        }
      )
      getSensorCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.sensorCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.sensorCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.sensorCurve, "sensorEchart")
      })
      await getSensorInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          let list = []
          for (let key in e.data) {
            list = [...list, ...e.data[key]]
          }
          this.sensorInfo = list.map((e) => {
            if (this.$i18n.locale == "en") {
              e.signName = e.enSignName
            }
            if (e.mean && e.value) {
              const mean = {}
              let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
              str.split(";").forEach((i) => {
                i = i.split(":")
                mean[i[0]] = i[1]
              })
              // console.log(e.value, mean[e.value], e.mean)
              e.value = mean[e.value]
            }
            if (e.factor > 1 && e.value) {
              e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
            }
            if (e.unit && e.value) {
              e.value = e.value + " " + e.unit
            }
            if (!e.value) {
              e.value = this.$t("cabinet.sensor.noData")
            }
            return e
          })
        }
      )
      getRectifyCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.rectifyCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.rectifyCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.rectifyCurve, "rectifyEchart")
      })
      await getRectifyInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          this.rectifyInfo =
            e.data.length &&
            e.data.map((e) => {
              if (this.$i18n.locale == "en") {
                e.signName = e.enSignName
              }
              if (e.mean && e.value) {
                const mean = {}
                let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
                str.split(";").forEach((i) => {
                  i = i.split(":")
                  mean[i[0]] = i[1]
                })
                // console.log(e.value, mean[e.value], e.mean)
                e.value = mean[e.value]
              }
              if (e.factor > 1 && e.value) {
                e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
              }
              if (e.unit && e.value) {
                e.value = e.value + " " + e.unit
              }
              if (!e.value) {
                e.value = this.$t("cabinet.sensor.noData")
              }
              return e
            })
        }
      )
      getPowerCurve({ deviceCode: this.seletedItem.deviceCode }).then((e) => {
        this.powerCurve = []
        for (let key in e.data) {
          let data = e.data[key].map((e) => [
            this.switchTimeFormat(e.time),
            e.value
          ])
          let list = data.map((e) => e[0])
          data = data.filter((e, i) => {
            return list.indexOf(e[0]) == i
          })
          this.powerCurve.push({
            date: e.data[key].map((e) => {
              return this.switchTimeFormat(e.time)
            }),
            name: e.data[key][0].field,
            data: data
          })
        }
        this.getBarChert(this.powerCurve, "powerEchart")
      })
      await getPowerInfo({ deviceCode: this.seletedItem.deviceCode }).then(
        (e) => {
          this.powerInfo =
            e.data.length &&
            e.data.map((e) => {
              if (this.$i18n.locale == "en") {
                e.signName = e.enSignName
              }
              if (e.mean && e.value) {
                const mean = {}
                let str = e.mean.replace(/; /g, ";").replace(/：/g, ":")
                str.split(";").forEach((i) => {
                  i = i.split(":")
                  mean[i[0]] = i[1]
                })
                // console.log(e.value, mean[e.value], e.mean)
                e.value = mean[e.value]
              }
              if (e.factor > 1 && e.value) {
                e.value = (e.value / e.factor).toFixed(e.factor > 10 ? 2 : 1)
              }
              if (e.unit && e.value) {
                e.value = e.value + " " + e.unit
              }
              if (!e.value) {
                e.value = this.$t("cabinet.sensor.noData")
              }
              return e
            })
        }
      )

      this.$nextTick(() => {
        this.rectifyNums = this.$refs.rectifybox.clientHeight / 18
        this.powerNums = this.$refs.powerbox.clientHeight / 18
        this.sensorNums = this.$refs.sensorbox.clientHeight / 18
        this.batteryNums = this.$refs.batterybox.clientHeight / 18
        // console.log(
        //   this.rectifyNums,
        //   this.powerNums,
        //   this.sensorNums,
        //   this.batteryNums
        // )
      })
    },
    switchTimeFormat(time) {
      const dateTime = new Date(time)
      const year = dateTime.getFullYear()
      const month = dateTime.getMonth() + 1
      const date = dateTime.getDate()
      const hour = dateTime.getHours()
      const minute = dateTime.getMinutes()
      const second = dateTime.getSeconds()
      return (
        year +
        "-" +
        this.addZero(month) +
        "-" +
        this.addZero(date) +
        " " +
        this.addZero(hour) +
        ":" +
        this.addZero(minute) +
        ":" +
        this.addZero(second)
      )
    },
    addZero(v) {
      return v < 10 ? "0" + v : v
    },
    getIcon(val) {
      switch (val) {
        case "TEMP":
          return "wenshidu"
        case "SOURCE":
          return "dianyuan"
        case "CABINET":
          return "danguiti"
        case "GF":
          return "guangfu"
        case "AIR":
          return "kongtiao"
        case "WATER":
          return "shuijin"
        case "BATTERY":
          return "dianchi"
        case "UPS":
          return "UPS"
        case "PD":
          return "peidian"
        case "FAN":
          return "fengjifengshan"
        case "SMOKE":
          return "yangan"
        case "DOOR":
          return "menjin"
        case "video":
          return "shipin"
        case "fire":
          return "xiaofang"
        case "fanglei":
          return "fanglei"

        default:
          return "wenshidu"
      }
    },
    getDeviceCountInfo() {
      getDeviceCountInfo().then((e) => {
        this.list =
          e.data.length &&
          e.data.map((e) => {
            e.icon = this.getIcon(e.typeCode)
            e.deviceCount = e.deviceCount || 0
            return e
          })
      })
    },
    getCabinetCountInfo() {
      getCabinetCountInfo().then((e) => {
        this.cabinetCount = e.data
        this.cabinetCount.total = e.data.multipleCount + e.data.singleCount
        this.cabinetCount.totalList = ("000000" + this.cabinetCount.total)
          .slice(-5)
          .split("")
        this.cabinetCount.multiple = parseFloat(
          ((e.data.multipleCount / this.cabinetCount.total) * 100).toFixed(1)
        )
        this.cabinetCount.single = parseFloat(
          ((e.data.singleCount / this.cabinetCount.total) * 100).toFixed(1)
        )
        // console.log(this.cabinetCount)
      })
    },
    getAlarmList() {
      getAlarmList({
        curPage: 1,
        pageSize: 99
      }).then((res) => {
        if (res.data.list.length > 0) {
          this.configTable.data = this.configTable = {
            header: [
              this.$t("alarm.device"),
              this.$t("alarm.alarmInfo"),
              this.$t("alarm.uploadTime"),
              this.$t("alarm.status")
            ],
            data: res.data.list.map((e) => [
              e.deviceName,
              e.alarmInfo,
              e.uploadTime,
              e.alarmStatus == 0
                ? `<span style="color:#29f0be;">${this.$t(
                    "alarm.processed"
                  )}</span>`
                : `<span style="color:#E2502C;">${this.$t(
                    "alarm.unprocessed"
                  )}</span>`
            ]),
            rowNum: 6, //表格行数
            headerBGC: "rgba(43, 244, 201, 0.15)", //表头
            evenRowBGC: "rgba(43, 244, 201, 0.1)", //奇数行
            oddRowBGC: "rgba(43, 244, 201, 0.05)", //偶数行
            // index: true,
            waitTime: 4000,
            align: ["left", "left", "left", "center"],
            // columnWidth: ['15%', '35%', '30%', '20%']
            columnWidth: [60]
          }
        } else {
          this.configTable = {
            header: [
              this.$t("alarm.device"),
              this.$t("alarm.alarmInfo"),
              this.$t("alarm.uploadTime")
            ],
            data: [["", this.$t("cabinet.sensor.noData"), ""]],
            rowNum: 6, //表格行数
            headerBGC: "rgba(43, 244, 201, 0.15)", //表头
            evenRowBGC: "rgba(43, 244, 201, 0.1)", //奇数行
            oddRowBGC: "rgba(43, 244, 201, 0.05)", //偶数行
            // index: true,
            waitTime: 4000,
            align: ["left", "left", "left", "center"],
            // columnWidth: ['15%', '35%', '30%', '20%']
            columnWidth: [60]
          }
        }
      })
    },
    getDeviceStatusInfo() {
      const myCharts = echarts.init(this.$refs.myCharts)
      function getParametricEquation(
        startRatio,
        endRatio,
        isSelected,
        isHovered,
        k,
        height
      ) {
        // 计算
        //  // console.log("getParametricEquation")
        let midRatio = (startRatio + endRatio) / 2

        let startRadian = startRatio * Math.PI * 2
        let endRadian = endRatio * Math.PI * 2
        let midRadian = midRatio * Math.PI * 2

        // 如果只有一个扇形，则不实现选中效果。
        if (startRatio === 0 && endRatio === 1) {
          isSelected = false
        }

        // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
        k = typeof k !== "undefined" ? k : 1 / 3

        // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
        let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0
        let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0

        // 计算高亮效果的放大比例（未高亮，则比例为 1）
        let hoverRate = isHovered ? 1.05 : 1

        // 返回曲面参数方程
        return {
          u: {
            min: -Math.PI,
            max: Math.PI * 3,
            step: Math.PI / 32
          },

          v: {
            min: 0,
            max: Math.PI * 2,
            step: Math.PI / 20
          },

          x: function (u, v) {
            if (u < startRadian) {
              return (
                offsetX +
                Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
              )
            }
            if (u > endRadian) {
              return (
                offsetX +
                Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
              )
            }
            return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate
          },

          y: function (u, v) {
            if (u < startRadian) {
              return (
                offsetY +
                Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
              )
            }
            if (u > endRadian) {
              return (
                offsetY +
                Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
              )
            }
            return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate
          },
          z: function (u, v) {
            if (u < -Math.PI * 0.5) {
              return Math.sin(u)
            }
            if (u > Math.PI * 2.5) {
              return Math.sin(u)
            }
            return Math.sin(v) > 0 ? height : -1
          }
        }
      }
      // 生成模拟 3D 饼图的配置项
      function getPie3D(pieData, internalDiameterRatio, boxHeight) {
        let series = []
        let sumValue = 0
        let startValue = 0
        let endValue = 0
        let legendData = []
        let k =
          typeof internalDiameterRatio !== "undefined"
            ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio)
            : 1 / 3

        let max = pieData.reduce((prev, current) =>
          prev.value > current.value ? prev.value : current
        )
        // console.log(max.value)
        max = 10 ** (parseInt(max.value).toString().length - 1)
        // 为每一个饼图数据，生成一个 series-surface 配置
        for (let i = 0; i < pieData.length; i++) {
          sumValue += pieData[i].value

          let seriesItem = {
            name:
              typeof pieData[i].name === "undefined"
                ? `series${i}`
                : pieData[i].name,
            type: "surface",
            parametric: true,
            wireframe: {
              show: false
            },
            pieData: pieData[i],
            pieStatus: {
              selected: false,
              hovered: false,
              k: k
            }
          }

          if (typeof pieData[i].itemStyle != "undefined") {
            let itemStyle = {}

            typeof pieData[i].itemStyle.color != "undefined"
              ? (itemStyle.color = pieData[i].itemStyle.color)
              : null
            typeof pieData[i].itemStyle.opacity != "undefined"
              ? (itemStyle.opacity = pieData[i].itemStyle.opacity)
              : null

            seriesItem.itemStyle = itemStyle
          }
          series.push(seriesItem)
        }

        // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
        // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
        for (let i = 0; i < series.length; i++) {
          endValue = startValue + series[i].pieData.value
          // console.log(series[i])
          series[i].pieData.startRatio = startValue / sumValue
          series[i].pieData.endRatio = endValue / sumValue
          series[i].parametricEquation = getParametricEquation(
            series[i].pieData.startRatio,
            series[i].pieData.endRatio,
            false,
            false,
            k,
            series[i].pieData.value / max
          )

          startValue = endValue

          legendData.push(series[i].name)
        }

        // 准备待返回的配置项，把准备好的 legendData、series 传入。
        let option = {
          tooltip: {
            formatter: (params) => {
              if (params.seriesName !== "mouseoutSeries") {
                return `${
                  params.seriesName
                }<br/><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                  params.color
                };"></span>${option.series[params.seriesIndex].pieData.value}`
              }
            }
          },
          legend: {
            show: false,
            data: legendData
          },
          xAxis3D: {
            min: -0.6,
            max: 0.6
          },
          yAxis3D: {
            min: -0.6,
            max: 0.6
          },
          zAxis3D: {
            min: -1,
            max: 1
          },

          grid3D: {
            show: false,
            boxHeight: boxHeight > 100 ? 5 : 50,
            environment: "auto", //背景色,auto为自适应颜色
            viewControl: {
              distance: 300,
              alpha: 25,
              beta: 90
            }
          },
          series: series
        }
        return option
      }
      getDeviceStatusInfo().then((e) => {
        let max =
          e.data.unOnlineCount > e.data.onlineCount
            ? e.data.unOnlineCount
            : e.data.onlineCount
        this.deviceType = e.data
        let option = getPie3D(
          [
            {
              name: this.$t("screen.onlineCount"),
              value: e.data.onlineCount - 0,
              itemStyle: {
                opacity: "0.5",
                color: "#29F0BE"
              }
            },

            {
              name: this.$t("screen.unOnlineCount"),
              value: e.data.unOnlineCount - 0,
              itemStyle: {
                opacity: "0.5",
                color: "#E2502C"
              }
            }
          ],
          1.5,
          max
        )
        myCharts.setOption(option)
      })
    },
    getBarChert(data, echart) {
      var mainEcharts = echarts.init(document.getElementById(echart))

      var option = {
        grid: {
          left: "5%",
          right: "15%",
          top: "25%",
          bottom: "5%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "rgba(255,255,255,0.7)"
            }
          },
          backgroundColor: "rgba(0,0,0,0.5)",
          padding: [5, 10],
          textStyle: {
            color: "rgb(255,255,255)"
          }
        },
        legend: {
          x: "center",
          y: 5,
          icon: "stack",
          itemWidth: 6,
          itemHeight: 5,
          textStyle: {
            color: "#FFFFFF",
            lineHeight: "6"
          },
          data: data.map((e) => e.name)
        },
        xAxis: {
          type: "time",
          data: data[0] && data[0].date,
          boundaryGap: true,
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255,255,255,0.5)"
            }
          },
          axisLabel: {
            margin: 10,
            textStyle: {
              fontSize: 14,
              color: "rgba(255,255,255,0.5)"
            },
            rotate: "45"
          }
        },
        yAxis: [
          {
            type: "value",
            position: "left",
            name: data[0] && data[0].unit,
            offset: 5,
            axisLabel: {
              color: "rgba(255,255,255,0.5)",
              textStyle: {
                fontSize: 12
              }
            },
            // scale: true,
            // minInterval: 1,
            max: (value) => {
              if (data[0] && data[0].unit == "℃") return 50
              return parseInt(value.max + 20)
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#2B6A61"
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#2B6A61",
                type: "dashed"
              }
            }
          },
          {
            type: "value",
            // scale: true,
            // minInterval: 1,
            max: (value) => {
              console.log(data[1] && data[1].unit, "--------2------------")
              if (data[1] && data[1].unit == "％") return 100
              return parseInt(value.max + 20)
            },
            name: data[1] && data[1].unit,
            position: data.length > 2 ? "left" : "right",
            axisLabel: {
              color: "rgba(255,255,255,0.5)",
              textStyle: {
                fontSize: 12
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#2B6A61"
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#2B6A61",
                type: "dashed"
              }
            }
          },
          {
            type: "value",
            // scale: true,
            // minInterval: 1,
            max: function (value) {
              return parseInt(value.max + 20)
            },
            name: data[2] && data[2].unit,
            position: "left",
            axisLabel: {
              color: "rgba(255,255,255,0.5)",
              textStyle: {
                fontSize: 12
              }
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#2B6A61"
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                color: "#2B6A61",
                type: "dashed"
              }
            }
          }
        ],
        series: [
          {
            name: data[0] && data[0].name,
            type: "line",
            smooth: true,
            showSymbol: false,
            data: data[0] && data[0].data,
            itemStyle: {
              normal: {
                color: "#f5bc4e"
              }
            },
            lineStyle: {
              normal: {
                width: 2
              }
            }
          },
          {
            name: data[1] && data[1].name,
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            showSymbol: false,
            symbol: "circle",
            symbolSize: 6,
            data: data[1] && data[1].data,
            itemStyle: {
              normal: {
                color: "#00ffd8"
              }
            },
            lineStyle: {
              normal: {
                width: 2
              }
            }
          },
          {
            name: data[2] && data[2].name,
            type: "line",
            smooth: true,
            yAxisIndex: 1,
            showSymbol: false,
            symbol: "circle",
            symbolSize: 6,
            data: data[2] && data[2].data,
            itemStyle: {
              normal: {
                color: "#f9632f"
              }
            },
            lineStyle: {
              normal: {
                width: 2
              }
            }
          }
        ]
      }

      mainEcharts.setOption(option, true)
    },

    getCabinetList() {
      const _this = this
      console.log(this.map, "this.map")
      if (!this.map) {
        this.loadMap()
      }
      getCabinetList().then((e) => {
        // console.log(e)
        const maplist = []
        this.mapList = e.data.list.map((i) => {
          const result = maplist.filter((item) => item === i.siteCode)
          maplist.push(i.siteCode)
          i.numIndex = result.length
          console.log(result, "1-----")
          return i
        })
        this.map.entities.clear()
        this.list.forEach((e) => {
          // eslint-disable-next-line no-undef
          let pin = new Microsoft.Maps.Pushpin(
            // 经纬度
            {
              latitude: e.latitude || 0,
              longitude: e.longitude || 0
            },
            {
              icon: require(`../../assets/images/cabinet/${
                e.online == 1 ? "normal" : "fault"
              }${e.cabinetType == 1 ? "" : "s"}.svg`), // 自定义图片路径
              // eslint-disable-next-line no-undef
              anchor: new Microsoft.Maps.Point(40 + e.numIndex * 30, 40),
              // 偏移
              title: e.deviceName
            }
          ) //Add the pushpin to the map
          this.map.entities.push(pin)
          // eslint-disable-next-line no-undef
          Microsoft.Maps.Events.addHandler(pin, "click", () => {
            _this.goLink(e)
            console.log(e, "Microsoft !== undefined")
          })
        })
      })
    },
    goLink(item) {
      if (item.deviceCode == this.seletedItem.deviceCode) return
      this.seletedItem = item
      this.map.setView({
        zoom: 15,
        // eslint-disable-next-line no-undef
        center: new Microsoft.Maps.Location(
          this.seletedItem.latitude,
          this.seletedItem.longitude
        )
      })
      this.changeCabinet()
    },
    initMap() {
      let lang = this.$i18n.locale
      lang = lang == "zh" ? "zh-CN" : lang
      console.log(lang, "lang")
      const bingKey =
        "As2AhniKpC-v86mSiiJVKNwebR8WcyYw9ICr4RDcnHhpCo5HwcSUPbyYjdoDn77R"
      const BingMapUrl =
        "http://www.bing.com/api/maps/mapcontrol?setLang=" +
        lang +
        "&key=" +
        bingKey
      // console.log(BingMapUrl)
      return new Promise((resolve, reject) => {
        if (typeof Microsoft !== "undefined") {
          console.log(timeout, "Microsoft !== undefined")
          // eslint-disable-next-line no-undef
          resolve()
          return true
        }

        // 插入script脚本
        let scriptNode = document.createElement("script")
        scriptNode.setAttribute("type", "text/javascript")
        scriptNode.setAttribute("src", BingMapUrl)
        document.body.appendChild(scriptNode)

        // 等待页面加载完毕回调
        let timeout = 0
        let interval = setInterval(() => {
          console.log(timeout, "加载...")
          // 超时20秒加载失败
          if (timeout >= 40) {
            reject()
            clearInterval(interval)
          }
          // 加载成功
          if (typeof Microsoft !== "undefined") {
            resolve()
            clearInterval(interval)
          }
          timeout += 1
        }, 100)
      })
    },
    loadMap() {
      const _this = this
      // eslint-disable-next-line no-undef
      this.map = new Microsoft.Maps.Map(document.getElementById("myMap"), {
        zoom: 10,
        showCopyright: false,
        center: {
          latitude: this.seletedItem.latitude || 0,
          longitude: this.seletedItem.longitude || 0
        }
      })
      this.mapList.forEach((e) => {
        // eslint-disable-next-line no-undef
        let pin = new Microsoft.Maps.Pushpin(
          {
            latitude: e.latitude || 0,
            longitude: e.longitude || 0
          },
          {
            icon: require(`../../assets/images/cabinet/${
              e.online == 1 ? "normal" : "fault"
            }${e.cabinetType == 1 ? "" : "s"}.svg`), // 自定义图片路径
            // eslint-disable-next-line no-undef
            anchor: new Microsoft.Maps.Point(40 + e.numIndex * 25, 40),
            title: e.deviceName
            // eslint-disable-next-line no-undef
          }
        )
        //Add the pushpin to the map
        this.map.entities.push(pin)
        // eslint-disable-next-line no-undef
        Microsoft.Maps.Events.addHandler(pin, "click", () => {
          _this.goLink(e)
          console.log(e, "Microsoft !== undefined")
        })
      })
    },
    loadingMap() {
      const _this = this
      setTimeout(() => {
        console.log("检查是否加载成功...", _this.map)
        if (!_this.map) {
          _this.loadingMap()
        }
      }, 200)
      this.loadMap()
    },
    querySearch(queryString, cb) {
      let results
      if (!queryString) {
        results = this.mapList.map((e) => {
          return {
            label: e.deviceCode,
            latitude: e.latitude,
            longitude: e.longitude,
            value: e.deviceName
          }
        })
        cb(results)
      }
      queryString = queryString.replace(/[-]/g, "[-]")
      queryString = queryString.replace(/[(|（]/g, "[(]")
      queryString = queryString.replace(/[)|）]/g, "[)]")
      let regx = new RegExp(queryString)
      results = this.mapList.filter(
        (e) => regx.test(e.deviceCode) || regx.test(e.deviceName)
      )
      results = results.map((e) => {
        return {
          label: e.deviceCode,
          latitude: e.latitude,
          longitude: e.longitude,
          value: e.deviceName
        }
      })
      // console.log(results, this.list)
      cb(results)
    },
    handleFilter(e) {
      this.map.setView({
        // eslint-disable-next-line no-undef
        center: new Microsoft.Maps.Location(e.latitude, e.longitude),
        zoom: 15
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@keyframes up {
  0% {
    background-image: url(../../assets/images/screen/r1.png);
  }
  12% {
    background-image: url(../../assets/images/screen/r2.png);
  }
  24% {
    background-image: url(../../assets/images/screen/r3.png);
  }
  36% {
    background-image: url(../../assets/images/screen/r4.png);
  }
  48% {
    background-image: url(../../assets/images/screen/r5.png);
  }
  54% {
    background-image: url(../../assets/images/screen/r6.png);
  }
  72% {
    background-image: url(../../assets/images/screen/r7.png);
  }
  86% {
    background-image: url(../../assets/images/screen/r8.png);
  }
  100% {
    background-image: url(../../assets/images/screen/r9.png);
  }
}
@keyframes up2 {
  0% {
    background-image: url(../../assets/images/screen/L0.png);
  }
  25% {
    background-image: url(../../assets/images/screen/L1.png);
  }
  50% {
    background-image: url(../../assets/images/screen/L2.png);
  }
  75% {
    background-image: url(../../assets/images/screen/L3.png);
  }
  100% {
    background-image: url(../../assets/images/screen/L4.png);
  }
}

@keyframes show {
  0% {
    background-image: url(../../assets/images/screen/clr.png);
  }
  100% {
    background-image: none;
  }
}
@keyframes show2 {
  0% {
    background-image: url(../../assets/images/screen/cll.png);
  }
  100% {
    background-image: none;
  }
}
.screen {
  height: 100%;
  width: 100%;
  background: url(../../assets/images/screen/bg.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  .up {
    width: 100px;
    height: 8px;
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    top: 80%;
    left: 68.5%;
    animation: up 10s linear 2s infinite;
  }
  .down {
    width: 100px;
    height: 8px;
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    top: 80%;
    right: 68.5%;
    transform: rotateY(180deg);
    animation: up 10s linear 2s infinite;
  }
}
.top {
  height: 86px;
  width: 100%;
  background: url(../../assets/images/screen/top.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  align-items: center;
  .text {
    width: 100%;
    text-align: center;
    font-size: 33px;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    color: #ffffff;
    background: linear-gradient(0deg, #54b1a7, #a1f4d6, #f8fcff);
    background-clip: text;
    color: transparent;
  }
}
.content {
  height: calc(100% - 86px);
  width: 100%;
  display: flex;
  position: relative;
  .left,
  .right {
    width: 23%;
    height: 100%;
    position: relative;
    .bg {
      position: absolute;
      top: -5px;
      width: 120px;
      height: 100%;
      background-repeat: no-repeat;
      background-size: auto 100%;
      animation: up2 3s linear 2s infinite;
    }
    .devList {
      height: 40%;
      width: 100%;
      position: relative;
      .title {
        left: 18.6%;
        top: 32px;
      }
      .card {
        position: absolute;
        top: 25%;
        left: 50px;
        height: 63%;
        overflow: hidden;
      }
      .list {
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        transition: 0.3s;
      }
      .item {
        display: flex;
        width: 50%;
        height: 25%;
        align-items: center;
        .icon {
          width: 46px;
          height: 46px;
          padding: 2px;
          background: rgba(1, 23, 32, 0.2);
          border: 1px solid rgba(247, 247, 247, 0.2);
          border-radius: 50%;
          box-shadow: 0 0 6px rgba(255, 255, 255, 0.2);
          font-size: 40px;
          margin-right: 10px;
          margin-left: 10px;
          .iconfont {
            width: 40px;
            height: 40px;
            display: block;
            border: 2px solid #91fded;
            border-radius: 50%;
            background: linear-gradient(0deg, #45e9f4, #b7fafe, #f8fcff);
            background-clip: text;
            color: transparent;
            font-size: 26px;
            text-align: center;
            line-height: 36px;
          }
        }
        .dev {
          height: 46px;
          flex: 1;
        }
        .val {
          width: 100%;
          height: 18px;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #c7fcee;
          line-height: 18px;
          text-indent: 6px;
          border-left: 2px solid #2bf4c9;
          background: linear-gradient(
            -90deg,
            rgba(9, 27, 27, 0) 30%,
            #238772 100%
          );
        }
        .num {
          height: 26px;
          font-size: 20px;
          line-height: 20px;
          font-family: Helvetica;
          font-weight: 400;
          color: #2bf4c9;
          display: flex;
          align-items: flex-end;
          .n {
            font-size: 12px;
            line-height: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2bf4c9;
          }
        }
      }
    }
  }
  .right {
    .bg {
      right: 0;
      transform: rotateY(180deg);
    }
    .devInfo {
      height: 30.9%;
      width: 100%;
      position: relative;
    }
  }
  .left {
    .deviceType {
      height: 23%;
      width: 100%;
      padding-left: 30px;
      .device {
        padding-top: 30px;
        display: flex;
        height: 100%;
      }
      .myCharts {
        flex: 1;
      }
    }
    .legend {
      display: flex;
      padding: 20px 0;
      min-width: 150px;
      flex-direction: column;
      justify-content: space-around;
      .legend-item {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #c7fcee;

        .point {
          display: inline-block;
          position: relative;
          width: 16px;
          height: 16px;
          background: rgba(41, 240, 190, 0.15);
          border-radius: 50%;
          margin: 0 7px;
          top: 3px;
          &:before {
            content: "";
            display: inline-block;
            width: 8px;
            height: 8px;
            background: rgba(41, 240, 190, 1);
            border-radius: 50%;
            position: absolute;
            left: 4px;
            top: 4px;
          }
        }
        &.finish {
          .point {
            background: rgba(226, 80, 44, 0.15);
            &:before {
              content: "";
              background: rgba(226, 80, 44, 1);
            }
          }
        }
        .num {
          text-indent: 30px;
          font-size: 20px;
          font-family: Helvetica;
          font-weight: 400;
          color: #29f0be;
        }
      }
    }
    .alarm {
      height: 30%;
      width: 100%;
      padding-left: 30px;
      .alarmtable {
        padding-top: 58px;
        height: 290px;
      }
    }
  }
  .left:before {
    content: "";
    width: 30px;
    height: 30px;
    display: block;
    position: absolute;
    left: 0;
    top: -14px;
    background: url(../../assets/images/screen/spareL.png) no-repeat;
    background-size: 100% 100%;
  }
  .right:before {
    content: "";
    width: 30px;
    height: 30px;
    display: block;
    position: absolute;
    right: 0;
    top: -14px;
    background: url(../../assets/images/screen/spareR.png) no-repeat;
    background-size: 100% 100%;
  }
  .center {
    width: 54%;
    height: 100%;
    position: relative;
    .bg {
      width: 82px;
      top: -4px;
      position: absolute;
      height: calc(100% - 10px);
      background: url(../../assets/images/screen/cl.png) no-repeat;
      background-size: auto 100%;
      .corner {
        width: 40px;
        height: 11.8%;
        position: absolute;
        top: 6.7%;
        right: 0;
        animation: show 1s linear 2s infinite;
        background-size: auto 100%;
        background-repeat: no-repeat;
      }
      .bottom {
        width: 28px;
        height: 8.55%;
        position: absolute;
        bottom: 2%;
        animation: show2 1s linear 2s infinite;
        background-size: auto 100%;
        background-repeat: no-repeat;
      }
    }
    .bgr {
      right: 0;
      transform: rotateY(180deg);
    }
    .cabinetNum {
      width: 80%;
      margin: 2.5% auto;
      height: 10%;
      background: url(../../assets/images/screen/cabinetNum.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 28px;
      .cir {
        width: 60px;
        height: 60px;
      }
      .cabNum {
        display: flex;
        text-align: center;
        .row {
          margin: 0 5px;
          max-width: 101px;
        }
        .num {
          font-size: 20px;
          font-family: Helvetica;
          font-weight: 400;
          color: #47e5bc;
        }
        .text {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #c7fcee;
        }
      }
      .cabtTotal {
        width: 260px;
        .text {
          text-align: center;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #47e5bc;
          line-height: 20px;
          margin-bottom: 4px;
        }
        .totalList {
          display: flex;
          justify-content: space-around;
          div {
            width: 40px;
            height: 51px;
            text-align: center;
            line-height: 51px;
            background: #12363b;
            border-radius: 2px;
            font-size: 40px;
            font-family: Helvetica;
            font-weight: 400;
            color: #47e5bc;
            box-shadow: rgb(0, 191, 173) 0px 0px 8px inset;
          }
        }
      }
    }
    .mapBox {
      width: 83.4%;
      height: 45%;
      margin: 0 auto;
      margin-bottom: 3%;
      background: #47e5cc;
      position: relative;

      .search {
        position: absolute;
        top: 24px;
        left: 24px;
        width: 304px;
        height: 38px;
        background: #164e56;
        border-radius: 2px;
        z-index: 1;
      }
    }
    .echartBox {
      height: 34%;
      width: 83.4%;
      margin: 0 auto;
      position: relative;
      display: flex;
      .item {
        padding: 36px 0 12px 0;
        display: flex;
        align-items: center;
        position: relative;
        width: 50%;
        height: 100%;
        .title {
          top: 0;
          left: -10px;
        }
        .info {
          width: 110px;
          height: 216px;
          position: relative;
          overflow: hidden;
          .box {
            position: relative;
            transition: 0.3s;
          }
          .label {
            line-height: 18px;
            font-size: 12px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #c7fcee;
          }
          .value {
            line-height: 18px;
            font-size: 13px;
            font-family: Helvetica;
            font-weight: 400;
            color: #2bf4c9;
          }
        }
        .echart {
          flex: 1;
          height: 250px;
          width: 80%;
        }
      }
    }
  }
  .right {
    .devInfo {
      display: flex;
      align-items: center;
      padding-top: 65px;
      .title {
        position: absolute;
        top: 32px;
        left: -45px;
      }
      .cabinetInfo {
        height: 182px;
        width: 100%;
        display: block;
        position: relative;
        .img {
          position: relative;
          height: 100%;
          width: 90px;
          color: #47e5cc;
          background: url(../../assets/images/screen/cabinetInfo.png) no-repeat;
          background-size: 100% 100%;
          .iconfont {
            position: absolute;
            font-size: 40px;
            top: calc(50% - 28px);
            left: -11px;
            line-height: 40px;
          }
        }
        .box {
          position: absolute;
          line-height: 15px;
          width: 100%;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #c7fcee;
          top: 6px;
          .text {
            display: flex;
            margin-bottom: 16px;
            align-items: center;
            span {
              display: inline-block;
            }
            .line {
              flex: 1;
              margin: 0 10px;
              height: 1.2px;
              background: linear-gradient(
                90deg,
                rgba(43, 244, 201, 0) 0%,
                #2bf4c9 100%
              );
            }
            .val {
              width: 220px;
              padding-right: 20px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}
.environmental,
.battery {
  padding: 36px 0 12px 0;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 34%;
  .title {
    top: 0;
    left: -10px;
  }
  .info {
    width: 110px;
    height: 216px;
    position: relative;
    overflow: hidden;
    .box {
      position: relative;
      transition: 0.3s;
    }
    .label {
      line-height: 18px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #c7fcee;
    }
    .value {
      line-height: 18px;
      font-size: 13px;
      font-family: Helvetica;
      font-weight: 400;
      color: #2bf4c9;
    }
  }
  .echart {
    flex: 1;
    height: 250px;
    width: 80%;
  }
}
.title {
  width: 410px;
  height: 36px;
  line-height: 36px;
  font-size: 17px;
  font-family: YouSheBiaoTiHei;
  font-weight: 400;
  text-indent: 46px;
  color: #47e5cc;
  background: url(../../assets/images/screen/title.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  .drop {
    display: inline-block;
    text-indent: 12px;
    &:before {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #50faf3;
      border-radius: 50%;
      margin-right: 6px;
      line-height: 36px;
      margin-bottom: 2px;
    }
  }
}
</style>
